export default __webpack_public_path__ + "static/media/link.edc31414.png";